import { Flex } from 'antd'
import React, { useCallback } from 'react'

import { Link } from '@suntex.core/nav'
import { AvatarType } from '@suntex.fim/enums'
import { Button } from '@suntex.fim/ui'

import type { AvatarPreviewProps } from '../../types/avatar'
import { getDefaultAvatar } from '../../utils/avatarUtils'

const AvatarPreview: React.FC<AvatarPreviewProps> = ({
  selectedAvatar,
  selectedColor,
  onSave,
  isLoading = false,
  currentLevel,
  currentStickers
}) => {
  const handleCustomSave = useCallback(() => {
    onSave(AvatarType.Custom)
  }, [onSave])

  const handleDefaultSave = useCallback(() => {
    onSave(AvatarType.Default)
  }, [onSave])

  const defaultAvatar = getDefaultAvatar(currentLevel, currentStickers)

  return (
    <Flex vertical align="center" className="avatar-rightbox">
      <Flex vertical align="center" gap={15}>
        <Flex
          align="center"
          justify="center"
          className="avatar-rightbox__preview"
          style={{
            backgroundColor: selectedColor
          }}
        >
          <Flex
            justify="center"
            align="center"
            className="avatar-rightbox__preview-icon"
          >
            <selectedAvatar.component />
          </Flex>
        </Flex>
        <Flex vertical gap={12}>
          <Link to="" style={{ textDecoration: 'none' }}>
            <Button
              intent="primary"
              style={{ cursor: 'pointer' }}
              onClick={handleCustomSave}
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save this Player Avatar'}
            </Button>
          </Link>
          <Link to="" style={{ textDecoration: 'none' }}>
            <Button
              intent="secondary"
              style={{ cursor: 'pointer' }}
              onClick={handleDefaultSave}
              disabled={isLoading}
              title={`Set default to ${defaultAvatar.name} avatar`}
            >
              Set Default to my Skill Avatar
            </Button>
          </Link>
        </Flex>
        <Flex vertical>
          <p className="fw-bold">Or</p>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default AvatarPreview
